import * as React from 'react';
import { ColumnHeader } from './Grid';
import { withTheme } from 'styled-components';
import { observer } from 'mobx-react';
import { inject } from '../utils';
import { Component } from 'react';
import VisuallyHiddenWrapper from './VisuallyHiddenWrapper';
import { computed } from 'mobx';
import { AccessibilityStore } from '../stores';
import { Theme } from '../models/Theme';

interface ColumnHeaderExpanderProps {
    theme?: Theme;
    showColumnHeader: boolean;
    accessibilityStore?: AccessibilityStore;
    rowSpan?: number;
}

@inject('accessibilityStore')
@observer
class ColumnHeaderExpander extends Component<ColumnHeaderExpanderProps, any> {
    @computed
    get columnHeaderContent() {
        const { showColumnHeader = false, accessibilityStore } = this.props;
        if (accessibilityStore) {
            return showColumnHeader ? (
                accessibilityStore.rowExpanderColumnHeader
            ) : (
                <VisuallyHiddenWrapper>
                    {accessibilityStore.rowExpanderColumnHeader}
                </VisuallyHiddenWrapper>
            );
        }
        return;
    }
    render() {
        const { theme, rowSpan } = this.props;

        return (
            <ColumnHeader
                paddingX="0"
                width="40px"
                {...theme.ColumnHeader}
                rowSpan={rowSpan}
            >
                {this.columnHeaderContent}
            </ColumnHeader>
        );
    }
}

export default withTheme(ColumnHeaderExpander) as any;



// WEBPACK FOOTER //
// ./src/Components/ColumnHeaderExpander.tsx